import { CartPriceText } from "src/components/cart/CartPriceText"
import { StorefrontCartItem } from "src/components/checkout/types"
import { formatPriceLong } from "src/utilities/price"

export type CartPriceProps = {
  item: StorefrontCartItem
}

export const CartPrice = ({ item }: CartPriceProps) => {
  const lineNetTotal = +item.totals.line_total / 100
  const lineTaxTotal = +item.totals.line_total_tax / 100
  const lineTotal = lineNetTotal + lineTaxTotal

  const lineNetSubtotal = +item.totals.line_subtotal / 100
  const lineTaxSubtotal = +item.totals.line_subtotal_tax / 100
  const lineSubtotal = lineNetSubtotal + lineTaxSubtotal

  const itemTotal = lineTotal / item.quantity
  const itemSubtotal = lineSubtotal / item.quantity

  return (
    <div>
      {itemTotal !== itemSubtotal && (
        <div className="line-through opacity-50">
          <CartPriceText>{formatPriceLong(itemSubtotal)}</CartPriceText>
        </div>
      )}
      <CartPriceText>{formatPriceLong(itemTotal)}</CartPriceText>
    </div>
  )
}
